<template>
  <div>
    <span v-if="hidePersonalSections">
      <representatives-form
        :form-model="formModel"
        :required="required"
      ></representatives-form>
    </span>

    <span v-else>
      <personal-form
        :title="`${local.personInformation.title} ( ${partyTypeRole} )`"
        :form-model="formModel"
        :required="required"
        :show-prisoner-form="!isRepresentative"
        :show-needs-translator-form="!isRepresentative || isAgent(formModel.relatedPartiesInfo[0])"
        :allow-address-check="allowAddressCheck"
        disabled
        :view-mode="viewMode"
        :party-roles="partyRoles"
        :existing-parties="existingParties"
        :show-party-role="showPartyRole"
      ></personal-form>

      <national-address-form
        v-if="formModel.partyType && isResidence"
        :form-model="formModel.nationalAddress"
        :national-addresses="formModel.nationalAddresses"
        :required="required && isResidence"
        :hide-inputs="formModel.unknownAddress"
        :show-more-address-details="showPersonAddress"
        :is-view-mode="viewMode"
      >
        <naj-input
          v-if="isDefendant(formModel) && (formModel.nationalAddresses||[] ).length == 0 "
          :type-id="formFieldType.checkbox"
          :value.sync="formModel.unknownAddress"
          :disabled="isViewMode || viewMode"
          :label="local.address.promiseNotKnowDefendantAddress"
          class="danger-input"
        ></naj-input>
      </national-address-form>

      <span v-if="isRepresentative">
        <representatives-form
          :form-model="formModel"
          :required="required"
        ></representatives-form>
      </span>

      <naj-address
        v-if="formModel.partyType && formModel.socialIdType && !isResidence"
        :title="local.titleHeader.residenceAddress"
        :form-model="formModel.residenceAddress"
        :required="required && !isResidence"
        :is-defendant-address-required="isDefendant(formModel) ? !formModel.unknownAddress : false"
        :show-inputs="!formModel.unknownAddress"
        :is-view-mode="viewMode"
      >
        <naj-input
          v-if="isDefendant(formModel)"
          :type-id="formFieldType.checkbox"
          :value.sync="formModel.unknownAddress"
          :disabled="isViewMode || viewMode"
          :label="local.address.promiseNotKnowDefendantAddress"
          class="danger-input"
        ></naj-input>
      </naj-address>

      <profession-form
        :form-model="formModel"
        :required="required"
        :is-view-mode="viewMode"
      ></profession-form>
    </span>
  </div>
</template>

<script>
import RepresentativesForm from './forms/representatives-form';
import PersonalForm from './forms/personal-form';
import ProfessionForm from './forms/profession-form';
import NationalAddressForm from './forms/national-address-form';
import { socialIdentityTypeEnum, casePartyRoleByIdEnum } from '@/helpers/enum.js';
import { isDefendant, isAgent, isDefendantOrDefendantRepresentative, isProsecutorOrProsecutorRepresentative } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapGetters: mapGlobalGetters } = createNamespacedHelpers('GlobalModule');
export default {
  inject: ['$validator'],
  components: {
    PersonalForm,
    ProfessionForm,
    RepresentativesForm,
    NationalAddressForm,
  },
  props: ['formModel', 'isRepresentative', 'required', 'hidePersonalSections', 'viewMode', 'showMoreAddressDetails', 'allowAddressCheck', 'showPartyRole' // اظهار صفة الطرف,
  , 'partyRoles', 'existingParties'],
  data() {
    return {
      isDefendant,
      isAgent,
      isDefendantOrDefendantRepresentative,
      isProsecutorOrProsecutorRepresentative,
    };
  },
  computed: {
    ...mapGetters(['isViewMode']),
    ...mapGlobalGetters({ currentUserSocialId: 'socialId' }),
    partyTypeRole() {
      var partyRoleValue = this.formModel.casePartyRole !== 0 ? this.formModel.casePartyRole : this.formModel.relatedPartiesInfo[0].casePartyRole;
      return (
        this.local.common.casePartyRoles[casePartyRoleByIdEnum[partyRoleValue]]
      );
    },
    isResidence() {
      return (
        this.formModel.socialIdType === socialIdentityTypeEnum.nationalId ||
        this.formModel.socialIdType === socialIdentityTypeEnum.regularResidency
      );
    },
    isCurrentUserProsecutorOrProsecutorRepresentative() {
      return this.formModel.socialId === this.currentUserSocialId && this.isProsecutorOrProsecutorRepresentative(this.formModel);
    },
    showPersonAddress() {
      return (this.showMoreAddressDetails && (this.isCurrentUserProsecutorOrProsecutorRepresentative || this.isDefendantOrDefendantRepresentative(this.formModel)));
    },
  },
};
</script>

<style lang="scss" scoped>
.danger-input {
  ::v-deep .v-label {
    color: red !important;
  }
}
</style>
